import { IUpdateControledePatrimonioInspecaoUseCase } from "../../../presentation/useCases/update/update_controlede_patrimonio_inspecao_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateControledePatrimonioInspecaoUseCase
 */

export class UpdateControledePatrimonioInspecaoUseCase implements IUpdateControledePatrimonioInspecaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateControledePatrimonioInspecao(
    idControleCentroCusto: number,
    idInspecaoMaquinaEquip: number,
    dataInspecao: Date | null,
    idMaquinaEquip: number,
    codigoMaquinaEquip: string | null,
  ): Promise<void> {
    await this.repository.updateControledePatrimonioInspecao(
      idControleCentroCusto,
      idInspecaoMaquinaEquip,
      dataInspecao,
      idMaquinaEquip,
      codigoMaquinaEquip,
    );
  }
}
